import { addChatResult, sendChatMessage } from '@/entities/task/api/chat';
import { useResultRequiredModalStore } from '@/entities/task/model/stores/result-required-modal';

export async function saveResultRequired(): Promise<void> {
  const s = useResultRequiredModalStore.getState();

  const taskIdRaw = s.payload?.taskId;
  if (!taskIdRaw) {
    throw new Error('ResultRequiredModal: payload.taskId is missing');
  }

  const taskId = String(taskIdRaw);
  const text = (s.resultText ?? '').trim();
  const files = (s.files ?? [])
    .map((f) => f.file)
    .filter((f): f is File => !!f);

  if (!text && files.length === 0) {
    throw new Error('ResultRequiredModal: empty text and no files');
  }

  // Запись результата (multipart). С файлами эндпоинт сам постит сообщение
  // в чат задачи и кладёт их в result.fileIds.
  await addChatResult(taskId, text, files);

  // Без файлов эндпоинт в чат не пишет — отправим текст сообщением отдельно,
  // чтобы результат был виден и в чате. Не критично: результат уже сохранён.
  if (files.length === 0) {
    try {
      await sendChatMessage(taskId, text);
    } catch (e) {
      console.warn('saveResultRequired: chat copy failed', e);
    }
  }
}
